import { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../contexts/AdminContext';
import { OptionsType, rolePermission } from '../interfaces/ApplicationInterfaces';
import './EditComponent.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import { ApplicationData, Claims, ExternalEnumRecord, claimEnabledInContext, claimsListToSchema, makeExternalEnumRecord } from '../interfaces/APIInterface';
import MenuItem from '@mui/material/MenuItem';
import { COSMOS_API, POST_ENDPOINT } from '../api/API';
import { ApplicationClaimField } from './ApplicationClaimField';
import { AppEnvSetting, isNullUndefEmpty } from '../ts/common';
import { ClaimsEditingForm } from './ClaimsEditingForm';

interface ClaimsEditProps {
    claimContext: Record<string, string>;
    updateClaims: (claimContext: Record<string, string>) => void;
    claimsSchema: Array<Claims>;
    claimsValid: (claimContext: Record<string, string>, claimsSchema: Array<Claims>) => boolean;
}

export const ClaimsEdit = (props: ClaimsEditProps) => {
    var { adminCredentials, getToken } = useContext(AdminContext);

    const [localClaimsContext, setLocalClaimsContext] = useState<Record<string, string>>({ ...props.claimContext });
    const [enableEditing, setEnableEditing] = useState<boolean>(false);

    const updateLocalContext = (newContext: Record<string, string>) => {
        props.claimsSchema?.filter(clm => !claimEnabledInContext(clm, claimsListToSchema(props.claimsSchema), clm.possibleValues, newContext)).forEach(disabledClm => {
            if (Object.keys(newContext).includes(disabledClm.id) && (!disabledClm.hidden)) { // Don't clear hidden claims
                newContext[disabledClm.id] = '';
            }
        });
        setLocalClaimsContext({ ...newContext });
    }

    return (
        <TableContainer
            component={Paper}
            className={'table-wrap in-page-apptable'}
            style={{ "overflowY": "auto" }}
        >
            <ClaimsEditingForm
                claimContext={localClaimsContext}
                updateClaims={updateLocalContext}
                claimsSchema={props.claimsSchema}
                disabled={!enableEditing}
            />
            {(adminCredentials.isOrganizationAdmin || adminCredentials.isSuperAdmin) && (
                enableEditing ? (
                    <Stack direction={"row"} spacing={4}>
                        <Button disabled={!props.claimsValid(localClaimsContext, props.claimsSchema)} onClick={() => { props.updateClaims({ ...localClaimsContext }); setEnableEditing(false); }}>Save Changes</Button>
                        <Button onClick={() => { setLocalClaimsContext({ ...props.claimContext }); setEnableEditing(false); }}>Discard Changes</Button>
                    </Stack>
                ): (
                    <Button onClick={() => setEnableEditing(true)}>Edit Claims</Button>
                )
            )}
        </TableContainer>
    )
}